var glofun = {
    //全局打印
    iconfonturl:"http://at.alicdn.com/t/font_616698_jduoxi5xl2lqh0k9.css",
    Alert: function (res, num) {
        if (num == '411') {
            console.dir(res);
        }
    },
    //验证只能是字母数字汉字组成
    letter: /^[\u4E00-\u9FA5A-Za-z0-9]+$/,
    //判断空的正则
    isnull: /^\s*$/,
    passReg: /^\S{6,}$/,
    //邮箱的验证
    emaireg: /^[.a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
    phonereg:/\d{7,12}/,
    //生成随机数
    random: function () {
        return String(Math.random()).substr(2, 6);
    },
    google_short_url_key:"https://firebase.google.com/docs/dynamic-links/restAIzaSyBfyQFDrs1Ysib0qB9MmvP8Y4PGzan22oY"
}

export  {glofun};




// WEBPACK FOOTER //
// ./src/util/util.js